import { useLayoutEffect } from "react";

import {
  acquireBootstrapLoader,
  releaseBootstrapLoader,
} from "./bootstrapLoaderHost";

/**
 * Keeps the singleton bootstrap loader mounted for the lifetime of the caller.
 * Overlapping gates (auth → jwt → route) share one host so the progress bar
 * does not remount.
 */
export function useBootstrapLoaderGate(active: boolean) {
  useLayoutEffect(() => {
    if (!active) {
      return;
    }
    acquireBootstrapLoader();
    return () => {
      releaseBootstrapLoader();
    };
  }, [active]);
}
